import { Contact } from 'packages/cosell/src/types/requests/AceOpportunityRequest';

// Internal data structure to help organize our contacts (not sent to API)
type ContactRole = 'PrimaryContact' | 'SecondaryContact';
interface AwsContactPersonaInternal {
  contact: Contact;
  role: ContactRole;
}

// AWS ACE representative personas for generating realistic contact information
const awsContactPersonas: AwsContactPersonaInternal[] = [
  {
    contact: {
      email: 'olivia.turner@aws-ace.example.com',
      businessTitle: 'AWSSalesRep',
      firstName: 'Olivia',
      lastName: 'Turner',
    },
    role: 'PrimaryContact',
  },
  {
    contact: {
      email: 'michael.patel@aws-ace.example.com',
      businessTitle: 'AWSAccountOwner',
      firstName: 'Michael',
      lastName: 'Patel',
    },
    role: 'SecondaryContact',
  },
  {
    contact: {
      email: 'emma.rodriguez@aws-ace.example.com',
      businessTitle: 'WWPSPDM',
      firstName: 'Emma',
      lastName: 'Rodriguez',
    },
    role: 'PrimaryContact',
  },
  {
    contact: {
      email: 'james.thompson@aws-ace.example.com',
      businessTitle: 'PDM',
      firstName: 'James',
      lastName: 'Thompson',
    },
    role: 'SecondaryContact',
  },
  {
    contact: {
      email: 'sophia.clark@aws-ace.example.com',
      businessTitle: 'PSM',
      firstName: 'Sophia',
      lastName: 'Clark',
    },
    role: 'PrimaryContact',
  },
  {
    contact: {
      email: 'david.valdez@aws-ace.example.com',
      businessTitle: 'ISVSM',
      firstName: 'David',
      lastName: 'Valdez',
    },
    role: 'SecondaryContact',
  },
];

// Get three contacts: two primary and one secondary
export const getRandomAwsContacts = (): Contact[] => {
  const primaryContacts = awsContactPersonas.filter(
    (item) => item.role === 'PrimaryContact',
  );
  const secondaryContacts = awsContactPersonas.filter(
    (item) => item.role === 'SecondaryContact',
  );

  // Select two unique primary contacts
  const primaryIndex1 = Math.floor(Math.random() * primaryContacts.length);
  let primaryIndex2 = Math.floor(Math.random() * primaryContacts.length);
  while (primaryIndex2 === primaryIndex1) {
    primaryIndex2 = Math.floor(Math.random() * primaryContacts.length);
  }

  return [
    primaryContacts[primaryIndex1].contact,
    primaryContacts[primaryIndex2].contact,
    secondaryContacts[Math.floor(Math.random() * secondaryContacts.length)]
      .contact,
  ];
};
